<template>
	<svg
		:class="iconClasses"
		:style="iconStyle"
		:width="size"
		:height="size"
		:viewBox="viewBox"
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="xMidYMid meet"
		v-bind="$attrs"
		@click="$emit('click', $event)"
	>
		<use :xlink:href="iconPath" />
	</svg>
</template>

<style lang="scss" src="./VSvgIcon.scss" />

<script lang="ts">

export default defineComponent({
	name: "VSvgIcon",

	inheritAttrs: false,

	emits: ['click'],

	props: {
		/**
		 * Имя иконки — совпадает с именем .svg файла в src/assets/icons-set
		 * (без расширения). Используется как id внутри спрайта public/sprite.svg.
		 */
		name: {
			type: String,
			required: true,
		},
		/**
		 * Размер иконки в пикселях. Применяется и к width, и к height.
		 */
		size: {
			type: [String, Number],
			default: 18,
		},
		/**
		 * viewBox SVG-символа. По умолчанию подходит для иконок,
		 * нарисованных в холсте 0 0 24 24.
		 */
		viewBox: {
			type: String,
			default: '0 0 24 24',
		},
	},

	computed: {
		iconPath(): string {
			const base = import.meta.env.BASE_URL?.replace(/\/$/, '') ?? '';
			return `${base}/sprite.svg#${this.name}`;
		},
		iconClasses(): Record<string, boolean> {
			return {
				'svg-icon': true,
				[`svg-icon--${this.name}`]: true,
			};
		},
		iconStyle(): Record<string, string> {
			return {
				'--icon-size': `${this.size}px`,
			};
		},
	},
});
</script>
